var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.idtesto == 1)?_c('testo1'):_vm._e(),(_vm.idtesto == 2)?_c('testo2'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }